// Заголовок страницы (components/PageHeader/README.md): page-title, одна строка пояснения,
// пилюли MetaChip; действия справа — вторичные, затем одна кнопка-акцент последней.
// До 640 px вторичные действия скрываются, остаётся главное.
import type { ReactNode } from 'react';
import { cx } from '../lib/cx.ts';

export interface PageHeaderProps {
  title: ReactNode;
  note?: ReactNode;
  /** Пилюли MetaChip под пояснением. */
  meta?: ReactNode;
  /** Вторичные действия. */
  secondaryActions?: ReactNode;
  /** Главное действие — последнее справа. */
  primaryAction?: ReactNode;
  className?: string;
}

export function PageHeader({
  title,
  note,
  meta,
  secondaryActions,
  primaryAction,
  className,
}: PageHeaderProps) {
  const hasActions = secondaryActions != null || primaryAction != null;
  return (
    <header className={cx('t-ph', className)}>
      <div className="kp-ph-main">
        <h1>{title}</h1>
        {note != null ? <p>{note}</p> : null}
        {meta != null ? <div className="kp-ph-meta">{meta}</div> : null}
      </div>
      {hasActions ? (
        <div className="acts">
          {secondaryActions != null ? (
            <div className="t-row kp-hide-phone">{secondaryActions}</div>
          ) : null}
          {primaryAction}
        </div>
      ) : null}
    </header>
  );
}
